import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Heading, Img, Text, Button, Input } from "../../components";

export default function LandingPage() {
  // State to track the selected team member's name and position
  const [selectedMember, setSelectedMember] = useState({
    name: "",
    position: "",
  });

  // Function to handle image click and update selected member state
  const handleMemberClick = (name, position) => {
    setSelectedMember({
      name: name,
      position: position,
    });
  };

  return (
    <>
      <Helmet>
        <title>Landing Page</title>
        <meta name="description" content="Web site created using create-react-app" />
      </Helmet>
      <div className="flex flex-col items-center justify-start w-full pt-5 bg-white-A700">
        <header className="flex flex-row md:flex-col justify-between items-center w-[89%] md:gap-10">
          <div className="flex flex-row justify-center items-center w-[15%] md:w-full gap-[7px]">
            <Img src="images/logo_main.png" alt="image" className="h-[35px]" />
            <div className="flex flex-row justify-start w-[74%]">
              <Heading size="md" as="h1" className="!text-[#7DC252] !font-bold">
                FarmAi
              </Heading>
            </div>
          </div>
          <ul className="flex flex-row sm:flex-col justify-between w-auto gap-[69px] sm:gap-10">
            <li>
              <a href="#about" className="mb-1">
                <Text as="p" className="!text-black-900_02">
                  About
                </Text>
              </a>
            </li>
            <li>
              <a href="#technologies">
                <Text as="p" className="!text-black-900_02">
                  Technologies
                </Text>
              </a>
            </li>
            <li>
              <a href="#team">
                <Text as="p" className="!text-black-900_02">
                  Team
                </Text>
              </a>
            </li>
            <li>
              <a href="#blog">
                <Text as="p" className="!text-black-900_02">
                  Blog
                </Text>
              </a>
            </li>
            <li>
              <a href="#partners">
                <Text as="p" className="!text-black-900_02">
                  Partners
                </Text>
              </a>
            </li>
          </ul>
          
        </header>
        <div id="about"></div>
        <div className="flex flex-col items-center justify-start w-full mt-[43px] md:px-5">
            <div className="flex flex-col items-center justify-start w-[90%] md:w-full">
              <div className="flex flex-row justify-center w-full">
                <div className="flex flex-row md:flex-col justify-between items-center w-full md:gap-10">
                  <div className="flex flex-col items-center justify-start w-[41%] md:w-full  md:mt-0">
                    <Heading as="h1">
                      <span className="text-black-900">Exploit the power of Ai in Agricultural Farms With </span>
                      <span className="text-[#7DC252]">FarmAi</span>
                    </Heading>
                    <Text as="p" className="mt-7">  
                      FarmAi is Ai with farm while we lorem that shit out of your face you dump extra bla bla
                    </Text>
                    <div className="flex flex-row sm:flex-col justify-start w-full mt-[54px] gap-2 sm:gap-5">
                      <Input
                        shape="round"
                        type="email"
                        name="email"
                        placeholder="Enter Your Email"
                        className="w-[59%]"
                      />
                      <Button className="round !bg-[#F9A165]">Join The Waitlist</Button>
                    </div>
                  </div>
                  <div className="h-[521px] w-[38%] md:w-full">
                    <Img
                      src="images/hero.svg"
                      alt="vector_one"
                      className="h-[489px] top-0 right-0 left-0 m-auto"
                    />                      
                  </div>
                </div>
              </div>
              <div id="technologies"></div>
              <div className="flex flex-row justify-center w-full mt-[92px]">
                <div className="flex flex-col items-center justify-between w-full gap-[75px]">
                  <div className="flex flex-col items-center justify-start w-[63%] md:w-full gap-[7px]">
                    <Heading as="h2" className="text-center">
                      We’re Offering
                    </Heading>
                    <Text as="p" className="text-center">
                      An early detection detection system of plants diseases, using the power of artificial intelligence
                      & drones
                    </Text>
                  </div>
                  <div className="flex flex-row md:flex-col justify-between items-end w-full md:gap-10">
                    <div className="flex flex-col items-center justify-start w-[27%] md:w-full">
                      <Img src="images/img_plants.svg" alt="plants_one" className="h-[88px]" />
                      <Text as="p" className="mt-[22px] !text-black-900_01">
                        Diseases Detection
                      </Text>
                      <Text size="s" as="p" className="mt-2 !text-gray-700_01 text-center">
                        Using our large variety of Ai Models
                      </Text>
                    </div>
                    <div className="flex flex-col items-center justify-start w-[27%] md:w-full">
                      <Img src="images/drone.svg" alt="image_one" className="h-[70px]" />
                      <Text as="p" className="mt-[23px] !text-black-900_01">
                        Drone Surveillance
                      </Text>
                      <Text size="s" as="p" className="mt-2 !text-gray-700_01 text-center">
                        Daily drone surveillance of your fields to check on their status
                      </Text>
                    </div>
                    <div className="flex flex-col items-center justify-start w-[27%] md:w-full">
                      <Img src="images/mobile_alert.svg" alt="image_one" className="h-[70px]" />
                      <Text as="p" className="mt-[23px] !text-black-900_01">
                      Mobile Alerts
                      </Text>
                      <Text size="s" as="p" className="mt-2 !text-gray-700_01 text-center">
                      Alerts sent directly to your phone about infections detected
                      </Text>
                    </div>
                  </div>
                </div>
              </div>
              <div id="team"></div>
              <Heading as="h3" className="mt-[95px]">
  Meet The Team
</Heading>
<Text as="p" className="w-[63%] mt-3 text-center">
  That have been working on building the projects from the grounds up
</Text>
{/* Team Role Section */}
<div className="flex flex-row md:flex-col justify-between items-start w-full mt-[61px] md:gap-10">
  <div className="flex flex-col items-start justify-start w-[27%] md:w-full gap-[65px]">
    
   {/* CEO role */}
<div className="flex items-center gap-3">
  <Heading
    size="md"
    as="h4"
    className={`mt-px ${selectedMember.position === "CEO" ? 'font-bold translate-x-[-10px] transition-all duration-500 ease-in-out' : 'font-normal'} !text-gray-900_01`}
  >
    CEO
  </Heading>

  {/* Dynamically render the selected member's name beside the role */}
  {selectedMember.position === "CEO" && selectedMember.name && (
    <Text
      size="lg"
      as="p"
      className={`!text-[#7DC252] opacity-0 transition-opacity duration-1000 ease-in ${selectedMember.position === "CEO" ? "opacity-100" : ""}`}
    >
      {selectedMember.name}
    </Text>
  )}
</div>

{/* COO role */}
<div className="flex items-center gap-3">
  <Heading
    size="md"
    as="h4"
    className={`mt-px ${selectedMember.position === "COO" ? 'font-bold translate-x-[-10px] transition-all duration-500 ease-in-out' : 'font-normal'} !text-gray-900_01`}
  >
    COO
  </Heading>

  {/* Dynamically render the selected member's name beside the role */}
  {selectedMember.position === "COO" && selectedMember.name && (
    <Text
      size="lg"
      as="p"
      className={`!text-[#7DC252] opacity-0 transition-opacity duration-1000 ease-in ${selectedMember.position === "COO" ? "opacity-100" : ""}`}
    >
      {selectedMember.name}
    </Text>
  )}
</div>

{/* Testing Chief role */}
<div className="flex items-center gap-3">
  <Heading
    size="md"
    as="h4"
    className={`mt-px ${selectedMember.position === "Testing Chief" ? 'font-bold translate-x-[-10px] transition-all duration-500 ease-in-out' : 'font-normal'} !text-gray-900_01`}
  >
    Testing Chief
  </Heading>

  {/* Dynamically render the selected member's name beside the role */}
  {selectedMember.position === "Testing Chief" && selectedMember.name && (
    <Text
      size="lg"
      as="p"
      className={`!text-[#7DC252] opacity-0 transition-opacity duration-1000 ease-in ${selectedMember.position === "Testing Chief" ? "opacity-100" : ""}`}
    >
      {selectedMember.name}
    </Text>
  )}
</div>

{/* R&D Manager role */}
<div className="flex items-center gap-3">
  <Heading
    size="md"
    as="h4"
    className={`mt-px ${selectedMember.position === "R&D Manager" ? 'font-bold translate-x-[-10px] transition-all duration-500 ease-in-out' : 'font-normal'} !text-gray-900_01`}
  >
    R&D Manager
  </Heading>

  {/* Dynamically render the selected member's name beside the role */}
  {selectedMember.position === "R&D Manager" && selectedMember.name && (
    <Text
      size="lg"
      as="p"
      className={`!text-[#7DC252] opacity-0 transition-opacity duration-1000 ease-in ${selectedMember.position === "R&D Manager" ? "opacity-100" : ""}`}
    >
      {selectedMember.name}
    </Text>
  )}
</div>

{/* Mobile Developer role */}
<div className="flex items-center gap-3">
  <Heading
    size="md"
    as="h4"
    className={`mt-px ${selectedMember.position === "Mobile Developer" ? 'font-bold translate-x-[-10px] transition-all duration-500 ease-in-out' : 'font-normal'} !text-gray-900_01`}
  >
    Mobile Developer
  </Heading>

  {/* Dynamically render the selected member's name beside the role */}
  {selectedMember.position === "Mobile Developer" && selectedMember.name && (
    <Text
      size="lg"
      as="p"
      className={`!text-[#7DC252] opacity-0 transition-opacity duration-1000 ease-in ${selectedMember.position === "Mobile Developer" ? "opacity-100" : ""}`}
    >
      {selectedMember.name}
    </Text>
  )}

      </div>
    
  


    
  </div>
{/* Right Section (for displaying team member images) */}
<div className="flex flex-col items-center justify-start w-[59%] md:w-full">
  <div className="flex flex-col items-center justify-start w-full md:w-full md:gap-10 z-[1]">

    {/* Top row */}
    <div className="flex flex-row justify-center items-center gap-[30px] w-full">
      <Img
        src={selectedMember.position === "CEO" ? "images/ouassimfull.jpg" : "images/ouassimfullBW.jpg"}
        alt="Ouassim Hamdani"
        className="w-[255px] h-[255px] object-cover rounded-md cursor-pointer transition-opacity duration-200"
        onClick={() => handleMemberClick("Ouassim Hamdani", "CEO")}
      />
      <Img
        src={selectedMember.position === "COO" ? "images/mohpic.jpg" : "images/mohblackandwite.jpg"}
        alt="Mohamed Aimen Benkoua"
        className="w-[255px] h-[255px] object-cover rounded-md cursor-pointer transition-opacity duration-200"
        onClick={() => handleMemberClick("Mohamed Aimen Benkoua", "COO")}
      />
      <Img
      src={selectedMember.position === "Testing Chief" ? "images/ryadpic.jpg" : "images/ryadpicBW.jpg"}
      alt="Ryad Ziane"
      className="w-[255px] h-[255px] object-cover object-top rounded-md cursor-pointer transition-opacity duration-200"
      onClick={() => handleMemberClick("Ryad Ziane", "Testing Chief")}
    />
    </div>
    
    {/* Bottom row */}
    <div  className="flex flex-row justify-center items-center gap-[30px] w-full mt-[30px]">
      <Img
        src={selectedMember.position === "R&D Manager" ? "images/ahlampic.jpg" : "images/ahlampicBW.jpg"}
        alt="Ahlam boumezrag"
        className="w-[255px] h-[255px] object-cover rounded-md cursor-pointer transition-opacity duration-200"
        onClick={() => handleMemberClick("Ahlam boumezrag", "R&D Manager")}
      />
      <Img
        src={selectedMember.position === "Mobile Developer" ? "images/abdoupic.jpg" : "images/abdoupicBW.jpg"}
        alt="Abderrahmane Herizi"
        className="w-[255px] h-[255px] object-cover rounded-md cursor-pointer transition-opacity duration-200"
        onClick={() => handleMemberClick("Abderrahmane Herizi", "Mobile Developer")}
      />
  
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="blog"></div>
            <Heading as="h6" className="mt-[85px]">
              Highlights
            </Heading>
            <Text as="p" className="mt-[9px] text-center">
              From our journey, as we reach closer and beyond our goals
            </Text>
            <div className="flex flex-row md:flex-col w-[92%] mt-[61px] gap-[88px] md:gap-10">
              <div className="flex flex-col items-center justify-start w-[29%] md:w-full pb-[11px] gap-2.5 bg-white-A700 shadow-xs shadow-gray-200 rounded-[10px]">
                <Img
                  src="images/img_rectangle_12.png"
                  alt="image"
                  className="w-full md:h-auto sm:w-full rounded-tr-[10px] rounded-tl-[10px] object-cover"
                />
                <div className="flex flex-col items-end justify-start w-[95%] md:w-full gap-3">
                  <Heading size="xs" as="h6" className="mr-px !text-gray-900">
                    FarmAi Secured a $100,000 Investment from Huawei
                  </Heading>
                  <Text size="xs" as="p" className="mr-px !text-blue_gray-700_01">
                    After months of research & work, FarmAi team was able to bring a $100,000 capital investment home,
                    this grand is targeted to be used to develop the startup & product.
                  </Text>
                  <Text size="xs" as="p" className="!text-[#F8A165]">
                    1 Month Ago
                  </Text>
                </div>
              </div>
              <div className="flex flex-col items-center justify-start w-[29%] md:w-full pb-[11px] gap-2.5 bg-white-A700 shadow-xs shadow-gray-200 rounded-[10px]">
                <Img
                  src="images/img_rectangle_12.png"
                  alt="image"
                  className="w-full md:h-auto sm:w-full rounded-tr-[10px] rounded-tl-[10px] object-cover"
                />
                <div className="flex flex-col items-end justify-start w-[95%] md:w-full gap-3">
                  <Heading size="xs" as="h6" className="mr-px !text-gray-900">
                    FarmAi Secured a $100,000 Investment from Huawei
                  </Heading>
                  <Text size="xs" as="p" className="mr-px !text-blue_gray-700_01">
                    After months of research & work, FarmAi team was able to bring a $100,000 capital investment home,
                    this grand is targeted to be used to develop the startup & product.
                  </Text>
                  <Text size="xs" as="p" className="!text-[#F8A165]">
                    1 Month Ago
                  </Text>
                </div>
              </div>
              <div className="flex flex-col items-center justify-start w-[29%] md:w-full pb-[11px] gap-2.5 bg-white-A700 shadow-xs shadow-gray-200 rounded-[10px]">
                <Img
                  src="images/img_rectangle_12.png"
                  alt="image"
                  className="w-full md:h-auto sm:w-full rounded-tr-[10px] rounded-tl-[10px] object-cover"
                />
                <div className="flex flex-col items-end justify-start w-[95%] md:w-full gap-3">
                  <Heading size="xs" as="h6" className="mr-px !text-gray-900">
                    FarmAi Secured a $100,000 Investment from Huawei
                  </Heading>
                  <Text size="xs" as="p" className="mr-px !text-blue_gray-700_01">
                    After months of research & work, FarmAi team was able to bring a $100,000 capital investment home,
                    this grand is targeted to be used to develop the startup & product.
                  </Text>
                  <Text size="xs" as="p" className="!text-[#F8A165]">
                    1 Month Ago
                  </Text>
                </div>
              </div>
            </div>
            <div id="partners"></div>
            <Heading as="h1" className="mt-[76px]">
              Meet Our Partners
            </Heading>
            <Text as="p" className="mt-[13px] text-center">
              Who are a building stone in our journey of starting up
            </Text>
            <div className="flex flex-row items-center justify-center sm:flex-col w-full mt-[74px] gap-[238px] md:gap-10">
              <Img src="images/pim.jpeg" alt="image" className="w-[14%] md:h-auto sm:w-full object-cover" />
              <Img src="images/img_image_5.png" alt="image" className="w-[14%] md:h-auto sm:w-full object-cover" />
              <Img src="images/inpv.png" alt="image" className="w-[14%] md:h-auto sm:w-full object-cover" />
            </div>
        </div>
        <footer className="flex justify-center items-center w-full mt-[92px] p-4 sm:p-5 bg-[#F8A165]">
          <div className="flex flex-row md:flex-col justify-between items-center w-full mb-[3px] mx-auto md:gap-10 md:px-5 max-w-[1341px]">
            <div className="flex flex-row sm:flex-col space-x-10 md:w-full sm:gap-10">
              <div className="flex flex-row justify-start items-center w-[54%] sm:w-full gap-[18px]">
                <Img src="images/logo_white.svg" alt="image_three" className="w-[30px]" />
                <div className="flex flex-row justify-start w-[69%]">
                  <Heading  className="!text-white-A700 text-3xl">
                    FarmAi
                  </Heading>
                </div>
              </div>
              <Img src="images/img_group_25.svg" alt="image_four" className="h-[30px]" />
            </div>
            <div className="flex flex-row justify-start items-center gap-5">
              <Img src="images/img_vector_white_a700_47x33.svg" alt="vector" className="h-[30px]" />
              <Heading size="s"  className="!text-white-A700 font-normal text-2xl">
                Algeria & Estonia
              </Heading>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
